/** Expands the Tools sidebar section if the PraxisPlay nav link is not yet visible. */
export async function ensurePraxisPlayNavVisible(): Promise<void> {
  const praxisPlayNav = document.querySelector("[data-tutorial-praxisplay-nav]") as HTMLElement | null;
  const isVisible =
    praxisPlayNav &&
    praxisPlayNav.getBoundingClientRect().width > 0 &&
    praxisPlayNav.getBoundingClientRect().height > 0;
  if (!isVisible) {
    const toolsToggle = document.querySelector("[data-tutorial-tools-toggle]") as HTMLElement | null;
    if (toolsToggle) {
      toolsToggle.click();
      await new Promise((resolve) => setTimeout(resolve, 150));
    }
  }
}
